import React, { Component, lazy } from "react";

const LoadableDashboardPage = lazy(() => import("./DashboardPage"));

class TemporaryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allFilters: this.getFilters(),
        };
    }

    getFilters = () => {
        const temporaryId = this.props.match.params.id;

        let allFilters = JSON.parse(sessionStorage.getItem(temporaryId));
        if (allFilters.origin === "viewConverstion") allFilters = this.handleTemporaryFilters(allFilters);
        if (allFilters.origin === "viewInsights") allFilters = this.handleTemporaryFilters(allFilters);
        return { ...allFilters };
    };

    componentDidMount() {
        // const temporaryId = this.props.match.params.id;
        // let allFilters = JSON.parse(sessionStorage.getItem(temporaryId));
        // if (allFilters.origin === "viewConverstion") allFilters = this.handleTemporaryFilters(allFilters);
        // if (allFilters.origin === "viewInsights") allFilters = this.handleTemporaryFilters(allFilters);
        // this.setState({ allFilters });
    }

    // componentWillUnmount() {
    //     const temporaryId = this.props.match.params.id;
    //     sessionStorage.removeItem(temporaryId);
    // }

    handleTemporaryFilters = (allFilters) => {
        let { filter, refineOptions } = allFilters;

        let extras = [];
        let filterSortType = filter.orderBy ? filter.orderBy : "published_date_desc";

        if (filter.extras) {
            filter.extras.forEach((element) => {
                if (element.key === "Sentiment") {
                    refineOptions.sentiment = element.value;
                } else if (element.key === "post_media_type") {
                    if (!["long_video", "short_video"].includes(refineOptions.media)) refineOptions.media = element.value;
                } else extras.push(element);
            });
        }

        if (filter.logos || filter.objects || filter.scenes) {
            allFilters.filterImageOptions.logos = JSON.parse(JSON.stringify(filter.logos ? filter.logos : []));
            allFilters.filterImageOptions.objects = JSON.parse(JSON.stringify(filter.objects ? filter.objects : []));
            allFilters.filterImageOptions.scenes = JSON.parse(JSON.stringify(filter.scenes ? filter.scenes : []));
        }

        filter.extras = extras;

        return { ...allFilters, filter, refineOptions, filterSortType };
    };

    render() {
        return (
            <LoadableDashboardPage
                {...this.props}
                dashboardPageType={this.state.allFilters.origin === "viewInsights" ? "temporaryInsights" : "temporary"}
                temporaryFilters={this.state.allFilters}
            />
        );
    }
}

export default TemporaryPage;
